import {Vue, Component} from 'vue-property-decorator';
import { Observer } from "mobx-vue";

import Navigation from '@/components/Navigation';
import Success from '@/components/Success';

import ResultStore from '@/store/ResultStore';
import PackageStore from '@/store/PackageStore';

@Observer
@Component
export default class Result extends Vue {
  
  constructor(props: any) {
    super(props)
  }
  
  state = {
    ResultStore,
    PackageStore
  }
  
  async mounted () {
    const orderId = window.localStorage.getItem('orderId')
    if (this.state.PackageStore.orderStatus === 2) {
     this.state.ResultStore.initResultStore()
    }
   await this.state.PackageStore.getOrderInfo(orderId)
  }
  
  beforeDestroy () {
    // 离开页面恢复数据至初始化状态
    this.state.ResultStore.resultStoreInit()
    this.state.PackageStore.resultStoreInit()
  }
  
  render() {
    return (
      <div>
        <Navigation title='支付结果' />
        <Success type={this.state.PackageStore.orderStatus} subTitle={this.state.ResultStore.subTitle} click={this.state.ResultStore.routerPushHome} />
      </div>
    )
  }
  
}